export default __webpack_public_path__ + "media/fonts/hpi-hf-icons-woff.woff2";